import init from './src/main';

function environmentReady() {
    const foucusOnFrame = () => {
        this.focus();
        window.removeEventListener('click', foucusOnFrame);
    };
    window.addEventListener('click', foucusOnFrame);

    window.removeEventListener('load', environmentReady);
    init();
}

window.addEventListener('load', environmentReady);
